import { trackEvent } from '@/infra/tracking/analytics'
import { safeTrackCall } from '@/presentation/pages/common-analytics'
import { UserProfileAssessmentModel } from '@/domain/models/profile-assessment/user-profile-assessment-model'

export namespace Analytics {
  export const trackOpenProfileAssessment = safeTrackCall(
    async (data: UserProfileAssessmentModel) => {
      trackEvent('up_profileAssessment_open', {
        data
      })
    }
  )

  export const trackProfileAssessmentCallback = safeTrackCall(
    async (data: UserProfileAssessmentModel) => {
      trackEvent('up_profileAssessment_callback', {
        data
      })
    }
  )

  export const trackProfileAssessmentDismiss = safeTrackCall(
    async (data: UserProfileAssessmentModel) => {
      trackEvent('up_profileAssessment_dismiss', {
        data
      })
    }
  )

  export const trackProfileAssessmentFinished = safeTrackCall(
    async (data: UserProfileAssessmentModel) => {
      trackEvent('up_profileAssessment_finished', {
        data
      })
    }
  )
}
